import { render, staticRenderFns } from "./ContractWithdrawalResult.vue?vue&type=template&id=53b56f66"
import script from "./ContractWithdrawalResult.vue?vue&type=script&lang=ts"
export * from "./ContractWithdrawalResult.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports